import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/products/headphones",
    name: "headphones",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "headphones" */ "../views/products/headphones.vue"
      ),
  },
  {
    path: "/products/headphones/quiet-comfort-earbud",
    name: "qcEarbuds",
    component: () => import("../views/products/quiet-comfort-earbud.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
